import React from 'react';
import { diffWords } from 'diff';

const Comparer = ({ oldString, newString }) => {
    const diff = diffWords(oldString, newString);

    return (
        <div>
            {diff.map((part, index) => {
                let style = {margin: 0, padding: '3px', whiteSpace: 'pre-wrap', lineHeight: '1rem'};
                if (part.added) {
                    style = { backgroundColor: '#b3ffb3', margin: 0, padding: '0px', whiteSpace: 'pre-wrap', lineHeight: '1rem' };
                } else if (part.removed) {
                    style = { backgroundColor: '#ffb3b3', margin: 0, padding: '0px', whiteSpace: 'pre-wrap', lineHeight: '1rem' };
                }
                return (
                    <span key={index} style={style}>
                        {part.value}
                    </span>
                );
            })}
        </div>
    );
};

export default Comparer;
